export default "__VITE_ASSET__BKIcdrZK__"